export const parseNotificationType = (notificationType) => {
  const { value } = notificationType || {};
  if (!!value) {
    return value;
  }
};
